module.exports = __webpack_public_path__ + "static/media/air-cargo-logistics-airplane-pallets-containers-freight.5b49944f.jpg";